import Snappy from '../../../libs/snappy/snappy';
import $ from 'jquery';

Snappy.Component.Topbar = class Topbar extends Snappy.BaseComponent {
	static get tagName() {
		return 'fa-topbar';
	}

	constructor(element) {
		super(element);
	}

	render() {
		this.setVars();
		this.setEventListeners();
		this.setEventListenersOnLargeViewport();
		this.queryUserStatus();
	}

	setEventListeners() {
		window.addEventListener('fa.viewportResize', this.onViewportResize.bind(this));
		this.$menuToggle.on('click', this.onMenuToggleClick.bind(this));
		this.$expandableLinks.on('click', this.onLinkItemClick.bind(this));
		this.$returnButtons.on('click', this.onReturnButtonClick.bind(this));
		this.$moreSitesButton.on('mouseover focus', this.onMoreSitesBtnHover.bind(this));
		this.$faSitesPrimaryLink.on('mouseover focus', this.onPrimaryLinkMoreAvailableHover.bind(this));
		this.$userButton.on('click', this.onUserButtonClick.bind(this));
	}

	setEventListenersOnLargeViewport() {
		if (!globalConfigs.viewportIsBelowLarge) {
			this.$moreSitesButton.on('mouseout focusout', this.onMenuBlur.bind(this, this.$moreFaSitesParent));
			this.$parentLinksContainer.on('mouseout focusout', this.onMenuBlur.bind(this, this.$moreFaSitesParent));
		}
	}

	onLinkItemClick(event) {
		if (globalConfigs.viewportIsBelowLarge) {
			const $link = $(event.currentTarget);

			$link.closest(this.moreClass).addClass(this.expandedClass);
			event.preventDefault();
		}
	}

	onViewportResize() {
		this.setEventListenersOnLargeViewport();
		this.menuIsActive = false;
		this.toggleMenu();
	}

	onReturnButtonClick(event) {
		const $returnCta = $(event.currentTarget);

		$returnCta.closest(this.moreClass).removeClass(this.expandedClass);
	}

	setVars() {
		this.menuIsActive = false;
		this.$menuToggle = this.$element.find('.controls__menu-toggle');
		this.$expandableLinks = this.$element.find('.more-available');
		this.$returnButtons = this.$element.find('.more-fa-sites__link--go-back');
		this.$moreSitesButton = this.$element.find('.more-fa-item__button');
		this.$moreFaSitesParent = this.$element.find('.topbar__primary-item.more-fa-item');
		this.$faSitesPrimaryLink = this.$element.find('.more-fa-sites__link.more-available');
		this.$parentLinksContainer = this.$element.find('.parent-links');
		this.menuActiveClass = 'menu-active';
		this.expandedClass = 'expanded';
		this.moreClass = '.more-fa-item';
		this.$userDetailsContainer = this.$element.find('.controls');
		this.$userButton = this.$userDetailsContainer.find('.controls__sign-in');
	}

	onMenuToggleClick() {
		this.menuIsActive = !this.menuIsActive;
		this.toggleMenu();
	}

	toggleMenu() {
		this.$element.toggleClass(this.menuActiveClass, this.menuIsActive);
	}

	onMoreSitesBtnHover() {
		this.$moreFaSitesParent.addClass(this.menuActiveClass);
	}

	onPrimaryLinkMoreAvailableHover(event) {
		const target = event && event.currentTarget;
		this.$activePrimaryLink = $(target).parent('.more-fa-sites__list-item');

		this.$activePrimaryLink.addClass(this.menuActiveClass);
		this.$activePrimaryLink.children().on('mouseout focusout', this.onMenuBlur.bind(this, this.$activePrimaryLink));

	}

	onMenuBlur($parent, event) {
		const toElement = event.toElement || event.relatedTarget;
		const toElementIsInContainingParent = $.contains($parent[0], toElement);

		if (!toElementIsInContainingParent) {
			$parent.removeClass(this.menuActiveClass);
		}
	}

	queryUserStatus() {
		const signInUrl = this.$userButton.data('isSignedInUrl');

		var currentHost = window.location.hostname;

		if (currentHost == "www.thefa.com" || currentHost == "beta.thefa.dev" || currentHost == "beta.thefa.test") {

		    $.ajax({
		        method: 'GET',
		        cache: false,
		        url: signInUrl
		    }).then(
                this.onUserStatusResponse.bind(this),
                this.onUserStatusError.bind(this)
            );
		}
	}

	onUserStatusResponse(response) {
		if (response && response.isLoggedIn) {
			this.$userButton.text(response.Html);
			this.$userDetailsContainer.addClass('user-signed-in');
		}
	}

	onUserStatusError() {
	}

	onUserButtonClick() {
		this.userMenuIsActive = !this.userMenuIsActive;

		this.toggleUserMenu();
	}

	toggleUserMenu() {
		this.$userDetailsContainer.toggleClass('account-menu-active', this.userMenuIsActive);
	}
};





// WEBPACK FOOTER //
// ./components/topbar/scripts/topbar.js